import './downloadReports.css';
import Frame from "../../frame";
import TotalCard from "../../TotalCard";
import {Button, Grid, Typography} from "@mui/material";
import {DataGrid, GRID_STRING_COL_DEF} from "@mui/x-data-grid";
import {useEffect, useState} from "react";
import format from "date-fns/format";
import axios from "axios";
import constants from "../../../constants";
import Loader from "../../loader";
import {useSelector} from "react-redux";
import useFormData from "../../../useFormData";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from '@mui/icons-material/Refresh';
import Box from "@mui/material/Box";

export default function DownloadReports() {

    let [data, setData] = useState(null);
    let [err, setError] = useState(null);
    let [nodata, setNodata] = useState(false);

    let [showLoader, setShowLoader] = useState(false);
    let config = useSelector(state => state.session.config);

    let [total, setTotal] = useState(0);
    let getFormData = useFormData();
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 25,
        page: 0,
    });



    async function getData(newModel) {
        setShowLoader(true);

        let offset = newModel.page * newModel.pageSize;

        let formData = getFormData();
        formData.append("action", "getRecords");
        formData.append("offset", offset);
        formData.append("limit", newModel.pageSize);

        let url = `${config.requestToDownloadURL}`;

        try {
            const response = await axios.post(url, formData, {
                timeout: config.apiTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                        setData(response.data.data);
                        setPaginationModel(newModel);
                        if (offset === 0) { //only for first req
                            setTotal(response.data.totalRecords || 0);
                        }
                        setNodata(false);
                    } else {
                        setNodata(true);
                    }
                } else {
                    setNodata(true);
                }

                if (response.data.status === "FAILURE") {
                    setNodata(true);
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
            setNodata(true);
        }
    }


    useEffect(() => {
        getData({
            pageSize: 5,
            page: 0,
        });
    }, []);

    function onPaginationModelChange(newModel) {
        getData(newModel)
    }

    return (<Frame>
            {
                nodata ?
                    <div style={{ textAlign: 'center' }}>No Download Requests Found!</div> : <Table data={data} onPaginationModelChange={onPaginationModelChange} total={total} model={paginationModel}/>
            }
            <Loader showLoader={showLoader} />
        </Frame>
    )
}

const statusActionColumn = {
    ...GRID_STRING_COL_DEF,
    resizable: false,
    filterable: false,
    sortable: false,
    editable: false,
    groupable: false,
    renderCell: (params) => <StatusAction row={params.row}/> ,
};

function StatusAction({row}) {
    // useEffect(() => {
    //     console.log(params);
    // }, []);

    if(row.Status === 'DOWNLOAD') {
        return <DownloadButton zipFileName={row.FileName}/>;
    } else {
        return row.Status;
    }
}


function Table({ data, onPaginationModelChange, total, model }) {

    if (!data) {
        return <></>;
    }

    let rows = data;

    function handleRefresh() {
        onPaginationModelChange({
            pageSize: model.pageSize,
            page: 0,
        });
    }

    let columns = [
        { field: 'StartDate', headerName: 'StartDate', width: 250, sortable: true },
        { field: 'EndDate', headerName: 'EndDate', width: 250, sortable: true },
        { field: 'Status', headerName: 'Status', width: 250, ...statusActionColumn }
    ];

    return (<>
        {/*<div style={{ marginTop: '5px', marginBottom: '5px' }}>*/}
        {/*    <TotalCard total={rows.length} />*/}
        {/*</div>*/}

       <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
           <Typography variant="body1">Download Report Requests:</Typography>
           <Button onClick={handleRefresh}><RefreshIcon/></Button>
       </Box>
        <Grid container spacing={1}>
            <Grid item lg={12}>
                <DataGrid rows={rows} columns={columns} getRowId={r => r.JobID}
                          pageSizeOptions={[5,10,20, 50]}
                          paginationModel={model}
                          onPaginationModelChange={onPaginationModelChange}
                          paginationMode="server"
                          rowCount={total}/>
            </Grid>
        </Grid>
    </>)
}

const DownloadButton = ({ zipFileName }) => {

    let config = useSelector(state => state.session.config);

    let userId = useSelector(state => state.session.userId);
    const handleDownload = () => {
        // const zipFileUrl = `${config.zipFilesFolderURL}/${userId}/${zipFileName}`; //when using userid folder
        const zipFileUrl = `${config.zipFilesFolderURL}/${zipFileName}`; //when using userid folder

        // Create an anchor element (a) to initiate the download
        const downloadLink = document.createElement('a');
        downloadLink.href = zipFileUrl;
        downloadLink.download = `${zipFileName}.zip`;

        // Simulate a click on the anchor element to trigger the download
        downloadLink.click();
    }

    return (
        <Tooltip title={zipFileName} placement='right'>
            <IconButton onClick={handleDownload}>
                <FileDownloadIcon color='success'/>
            </IconButton>
        </Tooltip>
    );
}
